import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter, Observable, tap } from 'rxjs';
import { ApiService } from '@us/web/shared/data-access';

@Injectable()
export class SetApiDomainInterceptor implements HttpInterceptor {
    private apiService = inject(ApiService);

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            filter(e => e instanceof HttpResponse),
            tap(event => {
                const headers = (event as unknown as HttpResponse<never>).headers;
                const apiDomain = headers.get('x-set-api-domain');
                if (apiDomain) {
                    this.apiService.setApiDomain(apiDomain);
                }
            })
        );
    }
}
